import { Link } from "react-router-dom";
import { faqs } from "@/mocks/faqs";

export default function FaqPreview() {
  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="text-center">
          <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">关于漫画软件应用的常见问题</h2>
          <p className="mt-2 text-sm text-foreground-600">挑选与使用漫画软件应用的高频疑问，这里都有答案</p>
        </div>

        <div className="mx-auto mt-8 grid max-w-4xl grid-cols-1 gap-3 md:grid-cols-2">
          {faqs.slice(0, 4).map((f) => (
            <article key={f.id} className="rounded-2xl border border-background-200/80 bg-background-100 p-5 transition-colors hover:border-primary-300">
              <div className="flex items-start gap-3">
                <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-500 text-sm font-black text-background-50">
                  Q
                </span>
                <div>
                  <h3 className="text-sm font-bold text-foreground-950 md:text-base">{f.question}</h3>
                  <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-700">{f.answer}</p>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link to="/faq" className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-bold text-primary-600 transition-colors hover:text-primary-700">
            查看更多常见问题
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}